<template>
    <button
        type="button"
        id="next-step"
        class="btn btn-primary font-weight-bolder dm-btn-wizard"
        data-wizard-type="action-next"
        :class="spinnerClasses"
        :disabled="disabled"
        @click="$emit('clicked')"
    >
        {{ buttonText }}
        <span class="svg-icon svg-icon-md ml-3">
            <ArrowRightSvg />
        </span>
    </button>
</template>

<script>
import ArrowRightSvg from "@/svg/ArrowRightSvg.vue";

export default {
    components: { ArrowRightSvg },

    props: ["saving", "is_active"],

    emits: ["clicked"],

    computed: {
        disabled() {
            if (this.is_active) return false;
            if (!this.saving) return true;
            return false;
        },
        buttonText() {
            if (this.saving) return this.translate("Saving...");
            return this.translate("Next");
        },
        spinnerClasses() {
            if (this.saving) return "spinner spinner-white spinner-right";
            return "";
        },
    },
};
</script>
